export default "__VITE_PUBLIC_ASSET__3eae1a69__"